export default __webpack_public_path__ + "static/media/screen4.55aab8b9.png";